const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-item" */ '@/pages/financial/tariff/furniture/item/index.vue'
  )

const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-item" */ '@/pages/financial/tariff/furniture/item/create.vue'
  )

const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-item" */ '@/pages/financial/tariff/furniture/item/edit.vue'
  )

export default {
  name: 'FinancialFurnitureItemTariff',
  path: 'item',
  meta: {
    label: 'itemTariff',
    auth: 'item'
  },
  component: {
    name: 'Item',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffItemReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateTariffItem',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditTariffItem',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
